'use strict';

var MailTemplateDetailCtrl = function(
  $scope,
  $state,
  gettextCatalog,
  template,
  placeholder,
  MailDA,
  Notification,
) {
  this._$state = $state;
  this._MailDA = MailDA;
  this._Notification = Notification;
  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
  this.template = template;
  this.placeholder = placeholder;
  this.gettextCatalog = gettextCatalog;
};

MailTemplateDetailCtrl.prototype.save = function() {
  var self = this;

  this._MailDA
    .update({
      name: this.template.name,
      content: this.template.content,
    })
    .then(function() {
      self._Notification.addSuccessMessage(self.gettextCatalog.getString('E-Mail Template saved'));
    })
    .catch(function(error) {
      self._Notification.addErrorMessage({ text: error });
    });
};

MailTemplateDetailCtrl.prototype.reset = function() {
  var self = this;

  this._MailDA
    .remove(this.template.name)
    .then(function() {
      self._Notification.addSuccessMessage(
        self.gettextCatalog.getString('E-Mail Template resetted'),
      );
      self._$state.reload();
    })
    .catch(function(error) {
      self._Notification.addErrorMessage({ text: error });
    });
};

module.exports = MailTemplateDetailCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/mailTemplate/MailTemplateDetailCtrl.js